import { h } from 'preact'
import { ModulesContext } from '../../utils/globals'

interface Props {
  name: string
  id: number | null
  rankIcon: string
  rankName: string
  pmUnreadCount: number
  avatar: string
}

export default function UserFlag (user: Props) {
  return (
    <ModulesContext.Consumer>
      {modules =>
        <div class='user flag'>
          <div class='flag__image'>

            <div class='avatar avatar--S js-menu-dropdown-toggle'>
              <a href={`/member/${user.name}-${user.id}`} class='qa-profilepicture'>

                <div class='profilepicture profile--dropdown-trigger'>
                  {user.avatar
                    ? <img src={user.avatar.replace('90x90', '100x100')} alt={user.name} />
                    : <div class={`default-avatar avatar-variant-${(user.id || 0) % 10}`}>
                      {user.name.toUpperCase()[0]}
                    </div>}
                </div>
                {modules.includes('rank') ? <div class='profilelabel'><img src={user.rankIcon} title={user.rankName} alt={user.rankName} /></div> : null}
              </a>
            </div>
            {modules.includes('privateMessage') && user.pmUnreadCount
              ? <a class='flag-notification' href='/inbox/overview'>{user.pmUnreadCount}</a>
              : null}
          </div>
        </div>}
    </ModulesContext.Consumer>
  )
}
